import type { SavedView } from '~/types/views';

export const getViewDisplayName = (
  view: Pick<SavedView, 'name'> | null | undefined,
  t: (key: string) => string
) => view?.name || t('dataGrid.views.defaultViewName');

const RESERVED_DEFAULT_VIEW_NAMES = [
  'Lemonway view',
  'Vue Lemonway',
  'Lemonway-Ansicht',
  'Vista Lemonway'
];

export const isReservedViewName = (name: string) => {
  const normalized = name.trim().toLowerCase();
  return RESERVED_DEFAULT_VIEW_NAMES.some((reserved) => reserved.toLowerCase() === normalized);
};
